module.exports = __webpack_public_path__ + "img/noveBloky.2edb0fea.jpg";